import React from "react";
import { getContextMenuOptions } from "./filemanager-utils";

const FileDropdownMenu = ({ selectedFiles, canPaste, onItemClicked, hasTarget, isSharedFolder, row }) => {
	const { perms } = hp.store;
	const options = getContextMenuOptions({ perms, hasTarget, isSharedFolder, canPaste, selectedFiles });

	return (
		<>
			<ul className="dropdown-menu w-med dropdown-menu-right" aria-labelledby={row.alias}>
				{options.filter(opt => opt.visible).map(opt => (
					<React.Fragment key={opt.key}>
						<li>
							<a
								className={`pointer ${opt.disabled ? "disabled" : ""}`}
								onClick={(e) => !opt.disabled && onItemClicked(e, opt.key)}
							>
								<em className={`ml-a ${opt.icon}`} />
								<span>{opt.label}</span>
							</a>
						</li>
                        {opt.dividerAfter && <li className="divider" />}
					</React.Fragment>
				))}
			</ul>
		</>
	);
};
export default FileDropdownMenu;